import { render } from "./SingleReport.vue?vue&type=template&id=3c6a42de&scoped=true"
import script from "./SingleReport.vue?vue&type=script&lang=js"
export * from "./SingleReport.vue?vue&type=script&lang=js"

import "./SingleReport.vue?vue&type=style&index=0&id=3c6a42de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6a42de"]])

export default __exports__